import React from 'react';
import { Result } from 'antd';

export const WidgetWarning = ({ message }) => {
  return <Result status="warning" subTitle={message} />;
};

export default WidgetWarning;
